import { render, staticRenderFns } from "./AtributeTabs.vue?vue&type=template&id=243aacf2&scoped=true&"
import script from "./AtributeTabs.vue?vue&type=script&lang=js&"
export * from "./AtributeTabs.vue?vue&type=script&lang=js&"
import style0 from "./AtributeTabs.vue?vue&type=style&index=0&id=243aacf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243aacf2",
  null
  
)

export default component.exports